import type { PostTheme, UTMAttrs } from '@/types';
import type { PropsWithChildren } from 'react';
import { PostContentContext } from './context';

type Props = PropsWithChildren<{
  utmParams?: UTMAttrs;
  postTheme?: PostTheme;
}>;

export function PostContentProvider({ children, utmParams, postTheme }: Props) {
  return <PostContentContext.Provider value={{ utmParams, postTheme }}>{children}</PostContentContext.Provider>;
}
